(function () {
	/* Temporarily un-hide any display:none ancestors so layout measurements
	   return real numbers (used for the FAQ hub's inactive category panels). */
	const withAncestorsVisible = (el, callback) => {
		const stack = [];
		let node = el;
		while (node && node !== document.body) {
			const cs = window.getComputedStyle(node);
			if (cs.display === "none") {
				stack.push({
					node,
					prevDisplay: node.style.display,
					prevVisibility: node.style.visibility,
					prevPosition: node.style.position,
				});
				node.style.display = "block";
				node.style.visibility = "hidden";
				node.style.position = "absolute";
			}
			node = node.parentElement;
		}
		let result;
		try {
			result = callback();
		} finally {
			/* Restore in reverse so nested overrides unwind cleanly. */
			stack.reverse().forEach((s) => {
				s.node.style.display = s.prevDisplay;
				s.node.style.visibility = s.prevVisibility;
				s.node.style.position = s.prevPosition;
			});
		}
		return result;
	};

	const lockAccordionHeight = ($items) => {
		/* Skip rules for the min-height lock:
		   • `.about` (product-page PDP accordions) — skipped on ALL
		     viewports. Design intent on the consumer PDP is that
		     opening an accordion grows the info column and pushes
		     the section below down, so a pre-locked height would
		     leave dead space under the closed accordions on desktop.
		   • `.how-it-works` — skipped only on mobile (≤ 749px) to
		     preserve the existing desktop-stable layout there.
		   Other containers still get the lock so they don't visually
		   reflow when the user switches between open accordions. */
		const isMobile = window.matchMedia("(max-width: 749px)").matches;

		$items.each(function () {
			const $container = $(this);
			$container.css("min-height", "");

			if ($container.closest(".about").length) {
				return;
			}
			if (isMobile && $container.closest(".how-it-works").length) {
				return;
			}

			const heights = [];

			withAncestorsVisible($container[0], () => {
				$container.find(".collapsible-content__item").each(function () {
					const $item = $(this);
					const $answer = $item.find(".collapsible-content__answer");
					const wasActive = $item.hasClass("active");
					const wasVisible = $answer.is(":visible");

					$item.addClass("active");
					$answer.show();
					heights.push($container.outerHeight());

					if (!wasActive) $item.removeClass("active");
					if (!wasVisible) $answer.hide();
				});
			});

			if (heights.length) {
				$container.css("min-height", Math.max.apply(null, heights) + "px");
			}
		});
	};

	/* Expose so faq-hub.js can re-run the lock when categories/search change
	   visibility and content count for a given container. */
	window.CollapsibleContent = window.CollapsibleContent || {};
	window.CollapsibleContent.lockAccordionHeight = lockAccordionHeight;

	const initCollapsibleContent = () => {
		$(".collapsible-content__toggle").off("click").on("click", function () {
			const parent = $(this).parent();

			if (!parent.hasClass("active")) {
				parent
					.siblings(".collapsible-content__item.active")
					.removeClass("active");
				parent.addClass("active");
				$(this)
					.closest(".collapsible-content__items")
					.find(".collapsible-content__answer")
					.stop()
					.slideUp(300);
				$(this).next().stop().slideDown(300);
			} else {
				parent.removeClass("active");
				$(this).next().stop().slideUp(300);
			}
		});

		$(".collapsible-content__item").mouseenter(function (event) {
			$(this).removeClass("collapsible-content__item--opacity");
			$(this)
				.siblings()
				.addClass("collapsible-content__item--opacity");
			$(this).mouseleave(() => {
				$(this)
					.siblings()
					.removeClass("collapsible-content__item--opacity");
			});
		});

		/* Lock every accordion container — including scrolling-steps (previously
		   excluded) and faq-hub's inactive category panels. The visibility
		   helper above measures hidden panels correctly. */
		lockAccordionHeight($(".collapsible-content__items"));
	};

	document.addEventListener("shopify:section:load", function () {
		initCollapsibleContent();
	});

	initCollapsibleContent();
})();
